//@actions
const signaturePatternActions = require('actions/signaturePattern');

//@helpers
const apiURLBuilder = require('core/apiURLBuilder');
const { APIPost } = require('utilities/APIRequestHelper');

//@constants
const actionTypes = require('constants/actionTypes');
const { DATE_FORMAT_API, FIRST_STEP } = require('constants/index');


const setUpStep = step => (dispatch, getState) => {
    let payload = {};

    if (step === FIRST_STEP) {
        const mobilePhoneNumber = getState().profile.get("telefonoContacto");
        if (mobilePhoneNumber) {
            payload.mobilePhone = mobilePhoneNumber.get("numero");
        } else {
            payload.mobilePhone = '';
        } 
    }

    dispatch({
        type: actionTypes.CARD_MOBILE_RECHARGE_SETUP_STEP,
        payload
    });
};

const setVisibleStep = (step) => ({
    type: actionTypes.CARD_MOBILE_RECHARGE_SET_VISIBLE_STEP,
    payload: { step }
})

const validateStep = (step) => ({
    type: actionTypes.CARD_MOBILE_RECHARGE_VALIDATE_STEP,
    payload: { step }
})

const setWillCancel = (willCancel) => ({
    type: actionTypes.CARD_MOBILE_RECHARGE_WILL_CANCEL,
    payload: { willCancel }
})

const resetView = () => ({type: actionTypes.CARD_MOBILE_RECHARGE_RESET_VIEW });

const operatorChanged = (code, label) => ({
    type: actionTypes.CARD_MOBILE_RECHARGE_OPERATOR_CHANGED,
    payload: {
        code,
        label
    }
})

const amountChanged = (value) => ({
    type: actionTypes.CARD_MOBILE_RECHARGE_AMOUNT_CHANGED,
    payload: { value }
})

const mobilePhoneChanged = (value) => ({
    type: actionTypes.CARD_MOBILE_RECHARGE_MOBILE_PHONE_CHANGED,
    payload: { value }
})

const setMobileRecharge = () => ({ type: actionTypes.SET_CARD_MOBILE_RECHARGE_REQUEST });

const setMobileRechargeSuccess = () => ({ type: actionTypes.SET_CARD_MOBILE_RECHARGE_SUCCESS });

const setMobileRechargeFailure = (error) => ({
    type: actionTypes.SET_CARD_MOBILE_RECHARGE_FAILURE,
    payload: {
        error: error.description
    }
})

const mobileRecharge = (cardId) => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const immCard = getState().cards.getIn(['byId', cardId]);
        const immCardMobileRechargeData = getState().cardMobileRecharge.getIn(['steps', 0]);
        const requestData = {
            query: {
                signaturePattern: dataToken,
                amount: immCardMobileRechargeData.getIn(['selectedAmount', 'amount']),
                cardStatus: immCard.get('status'),
                contractNumber: immCard.getIn(['contract', 'number']),
                currency: immCard.getIn(['availableBalance', 'currency']),
                expiryDate: immCard.get('expirationDate').format(DATE_FORMAT_API),
                operator: immCardMobileRechargeData.get('selectedOperator'),
                operatorCode: immCardMobileRechargeData.get('selectedOperatorCode'),
                pan: immCard.get('number'),
                phone: immCardMobileRechargeData.get('mobilePhone'),
                product: immCard.getIn(['contract', 'product'])
            },
        };

        dispatch(setMobileRecharge());
        return APIPost(dispatch, apiURLBuilder.getURL('setCardMobileCharge') , requestData)
            .then(response => dispatch(setMobileRechargeSuccess(response)))
            .catch(response => dispatch(setMobileRechargeFailure(response.error)))
    };

    new Promise(function () {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    })
}

module.exports = {
    setVisibleStep,
    validateStep,
    setWillCancel,
    mobileRecharge,
    resetView,
    operatorChanged,
    amountChanged,
    mobilePhoneChanged,
    setUpStep
};
